<template>
  <div class="log-in">
    <SignIn :default_create_account="defaultCreateAccount" @user-updated="userUpdated()"></SignIn>
  </div>
</template>


<script>
  import SignIn from "@/components/auth/SignIn.vue";

  export default {
    name: "LogInPage",
    components: {
      SignIn
    },
    props: ['default_create_account'],
    computed: {
      defaultCreateAccount() {
        return (this.$route.path === '/sign-up');
      },
    },
    mounted() {
      //console.log('query params', this.$route.query);
    },
    methods: {
      userUpdated() {
        this.$router.push({name: 'DashboardPage'});
      }
    }
  }

</script>


<style scoped>
.log-in {
  padding-top: 40px;
}
</style>